import { DetailedHTMLProps, forwardRef, LabelHTMLAttributes, memo, useId } from "react";
import classNames from "classnames";
import { RadioButtonBase, RadioButtonBaseProps } from "../../RadioButtonBase";

import styles from "./styles.module.scss";

export type RadioButtonGroupSize = "sm" | "md";

export type RadioButtonGroupItemProps = Omit<RadioButtonBaseProps, "radioButtonBaseSize"> & {
  labelProps?: Omit<DetailedHTMLProps<LabelHTMLAttributes<HTMLLabelElement>, HTMLLabelElement>, "className">
  inputPosition?: "start" | "end",
  radioButtonSize?: RadioButtonGroupSize,
  contentClassName?: string,
  radioButtonBaseClassName?: string,
}

export const RadioButtonGroupItem = memo(forwardRef<HTMLSpanElement, RadioButtonGroupItemProps>((
  {
    id,
    children,
    disabled,
    className,
    labelProps,
    inputPosition = "start",
    radioButtonSize,
    contentClassName,
    radioButtonBaseClassName,
    ...props
  }, ref,
) => {
  const reactId = useId();
  const realId = id || reactId;

  return (
    <label
      {...labelProps}
      className={classNames(
        styles.root,
        className,
        styles[radioButtonSize as keyof typeof styles],
        {
          [styles.disabled]: disabled,
          [styles.selected]: props.value === props.optionValue,
          [styles.reverted]: inputPosition === "start",
        },
      )}
      htmlFor={realId}
    >
      <div className={classNames(styles.content, contentClassName)}>{children}</div>
      <RadioButtonBase
        ref={ref}
        radioButtonBaseSize={radioButtonSize}
        className={radioButtonBaseClassName}
        disabled={disabled}
        id={realId}
        {...props}
      />
    </label>
  );
}));